import { useEffect, useState } from "react";
import { Button, ButtonGroup, Row } from "react-bootstrap";
import { AddModal, EditModal } from "./Modals";
import { DetailCol, ImgCol } from "./News";
import { addNews, deleteNews, fetchNews, updateNewsFirestore, updateNewsImage } from "../contexts/fetchNewsData";

const dataStructure = [
    {
        title: "Title",
        type: "text",
        field: "title",
        init: "",
    },
    {
        title: "Description",
        type: "textarea",
        field: "description",
        init: "",
    },
    {
        title: "URL Link",
        type: "text",
        field: "link",
        init: "",
    },
    {
        title: "Image",
        type: "file",
        field: "img",
        init: null,
    },
    {
        title: "Hidden?",
        type: "switch",
        field: "hidden",
        init: false,
    },
    {
        title: "Pinned?",
        type: "switch",
        field: "pinned",
        init: false,
    },
    {
        title: "Date",
        type: "date",
        field: "date",
        init: "",
    },
]


const excludedTypes = new Set(["file", "files"]);
const updateStructure = dataStructure.filter(el => !excludedTypes.has(el.type));

const onlyImgStructure = dataStructure.filter(el => excludedTypes.has(el.type));

const DBNews = () => {
    const [isShowA, setShowA] = useState(false);
    const [isShowE, setShowE] = useState(false);
    const [isShowI, setShowI] = useState(false);
    const [data, setData] = useState([]);
    const [eData, setEData] = useState({});

    useEffect(() => {
        fetchNews(setData)
        return () => {
            setShowA(false);
            setShowE(false);
            setShowI(false);
            setData([]);
            setEData({});
        };
    }, []);

    const handleAddSubmit = async (e, formData) => {
        e.preventDefault();
        try {
            await addNews(formData);
            await fetchNews(setData);
            setShowA(false);
        } catch (error) {
            console.error("Error in handleAddSubmit:", error);
            alert("Error uploading news. Please try again.");
        }
    };

    const handleEditSubmit = async (e, formData) => {
        e.preventDefault();
        try {
            await updateNewsFirestore(formData);
            await fetchNews(setData);
            setShowE(false);
        } catch (error) {
            console.error("Error in handleEditSubmit:", error);
            alert("Error updating news. Please try again.");
        }
    };

    const handleDeleteNews = async (id) => {
        const confirm = window.confirm("Are you sure you want to delete this news item?");
        if (!confirm) return;

        try {
            await deleteNews(id);
            await fetchNews(setData); // Refresh news list
        } catch (error) {
            console.error("Error deleting news:", error);
            alert("Error deleting news. Please try again.");
        }
    };

    const handleEditImageSubmit = async (e, formData) => {
        e.preventDefault();
        try {
            if (!formData.img || !(formData.img instanceof File)) {
                alert("Please select a valid image file.");
                return;
            }
            const id = eData.id
            // Must have an id from the existing data
            if (!id) {
                alert("Missing news ID.");
                return;
            }

            await updateNewsImage({ id, img: formData.img });

            await fetchNews(setData);
            setShowI(false);
        } catch (error) {
            console.error("Error in handleEditImageSubmit:", error);
            alert("Error updating news image. Please try again.");
        }
    };


    return (
        <div>
            <div className="text-end">
                <Button variant="primary" onClick={() => setShowA(true)}>Add</Button>
            </div>
            {data.map((d) => (
                <span key={d.id}>
                    <Row >
                        <ImgCol src={d.url} />
                        <DetailCol title={d.title} des={d.description} link={d.link} date={d.date} pinned={d.pinned} />
                    </Row>
                    <div className="text-end"><ButtonGroup>
                        <Button variant="warning" onClick={() => {setEData(d); setShowE(true);}}>Edit</Button>
                        <Button variant="dark" onClick={() => {setEData(d); setShowI(true);}}>Change Photo</Button>
                        <Button variant="danger" onClick={() => handleDeleteNews(d.id)}>Delete</Button>
                    </ButtonGroup></div>
                </span>
            ))}
            <AddModal  isShowM={isShowA} setShowM={setShowA} structure={dataStructure}   onSubmit={handleAddSubmit} />
            <AddModal  isShowM={isShowI} setShowM={setShowI} structure={onlyImgStructure} onSubmit={handleEditImageSubmit} mTitle="Change Photo"/>
            <EditModal isShowM={isShowE} setShowM={setShowE} structure={updateStructure} onSubmit={handleEditSubmit} existingData={eData}/>
        </div>
    )

}

export default DBNews;